/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Editor_Not_ReadyInputs */



/**
* | output |
* | --- |
* | "The editor is still loading — please try again in a moment." |
*
* @param {Suggestions_Editor_Not_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_editor_not_ready = /** @type {((inputs?: Suggestions_Editor_Not_ReadyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Editor_Not_ReadyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Editor lädt noch – bitte versuche es in einem Moment erneut.")
	return /** @type {LocalizedString} */ ("The editor is still loading — please try again in a moment.")
});